import { render, staticRenderFns } from "./EditTareaPage.vue?vue&type=template&id=a76ac9aa"
import script from "./EditTareaPage.vue?vue&type=script&lang=js"
export * from "./EditTareaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports